import { classNames } from '@/shared/lib/classNames';
import cls from './Skeleton.module.scss';

type Props = {
    className?: string;
    height: string;
    width: string;
};

export const Skeleton = ({ className, width, height }: Props) => {
    return <div className={classNames(cls.container, {}, [className])} style={{ width, height }}></div>;
};
